import React from 'react'
import { Toggle } from '../toggle/toggle.component'
import { useFilter } from '../../forms/hocs/filter.context.hoc'
import { useForm } from '../../forms/hocs/form.context'
import { FilterName } from '../../__generated__/fed-graphql-types'
import { StyledSearchFiltersToggle } from './search-filters-toggle.styles'

export const SearchFiltersToggle = ({
    otherFiltersToPassToOnChange,
}: {
    otherFiltersToPassToOnChange?: FilterName[]
}) => {
    const { filterName, options, selectedOptions, onValueChanged, title, subTitle } = useFilter()
    const { selectedMap } = useForm()
    const otherFilters =
        otherFiltersToPassToOnChange?.map((filterName) => ({
            filter: filterName,
            selected: selectedMap.get(filterName)?.values ?? [''],
        })) ?? []

    return (
        <StyledSearchFiltersToggle data-testid={`${filterName}-toggle-container`}>
            <Toggle
                options={options.map((option) => {
                    return {
                        displayValue: option.label,
                        value: option.value,
                        selected: selectedOptions.some((selectedOption) => selectedOption.value === option.value),
                    }
                })}
                id={`${filterName}-toggle`}
                name={`${filterName}-toggle`}
                onChange={(e) => {
                    e.currentTarget.checked = true
                    const selected = e.currentTarget.value
                    onValueChanged([selected], otherFilters)
                }}
                labelText={title}
                helpText={subTitle}
            />
        </StyledSearchFiltersToggle>
    )
}
